import Carousel from './Carousel'
import {
  Card,
  ImageWrapper,
  InfoWrapper,
  Header,
  Meta,
  Footer,
  Description,
  ImgSkeleton,
  LineSkeleton,
  StarSkeleton,
  StatSkeleton,
} from './CourseCard/styles'

export const CourseCardSkeleton = () => {
  return (
    <Card>
      <ImageWrapper>
        <ImgSkeleton />
      </ImageWrapper>
      <InfoWrapper>
        <Meta>
          <Header>
            <LineSkeleton w="40%" h="14px" />
            <LineSkeleton w="80%" h="20px" />
          </Header>
          <StarSkeleton />
          <Description>
            <LineSkeleton w="100%" h="50px" />
          </Description>
        </Meta>
        <Footer>
          <div style={{ display: 'flex', gap: '8px' }}>
            <StatSkeleton />
            <StatSkeleton />
          </div>
          <LineSkeleton w="80%" />
        </Footer>
      </InfoWrapper>
    </Card>
  )
}

export const CoursesSkeleton = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '32px', width: '100%' }}>
      <LineSkeleton w="80%" h="40px" />
      <Carousel>
        {Array.from({ length: 6 }).map((_, key) => (
          <CourseCardSkeleton key={key} />
        ))}
      </Carousel>
    </div>
  )
}
